export default __webpack_public_path__ + "static/media/emoji-meh.54ed6afd.svg";